import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/img/pass_ownership.svg'


const _hoisted_1 = ["data-userid"]
const _hoisted_2 = { class: "player-name" }
const _hoisted_3 = { class: "status-icons" }
const _hoisted_4 = ["id"]

import { SessionUser } from "@/App.vue";
import { UserID } from "@/IDTypes";
import { ReadyState } from "../../../src/Session/SessionTypes";


export default /*@__PURE__*/_defineComponent({
  __name: 'SessionUser',
  props: {
    index: {},
    user: {},
    self: {},
    sessionOwner: {},
    pendingReadyCheck: { type: Boolean },
    teamDraft: { type: Boolean },
    useCustomCardList: { type: Boolean },
    ignoreCollections: { type: Boolean },
    canRequestTakeover: { type: Boolean }
  },
  emits: ["removePlayer", "setSessionOwner", "requestTakeover", "movePlayer"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("li", {
    key: __props.user.userID,
    class: _normalizeClass({
			teama: __props.teamDraft && __props.index % 2 === 0,
			teamb: __props.teamDraft && __props.index % 2 === 1,
			draggable: __props.self === __props.sessionOwner,
			self: __props.self === __props.user.userID,
		}),
    "data-userid": __props.user.userID
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.user.userName), 1 /* TEXT */)
    ])), [
      [_directive_tooltip, __props.user.userName]
    ]),
    (__props.self === __props.sessionOwner)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-chevron-left",
            class: "clickable move-player move-player-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('movePlayer', __props.index, -1)))
          }, null, 512 /* NEED_PATCH */), [
            [_directive_tooltip, `Move ${__props.user.userName} to the left`]
          ]),
          _withDirectives(_createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-chevron-right",
            class: "clickable move-player move-player-right",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('movePlayer', __props.index, 1)))
          }, null, 512 /* NEED_PATCH */), [
            [_directive_tooltip, `Move ${__props.user.userName} to the right`]
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (__props.user.userID === __props.sessionOwner)
        ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "fa-solid fa-crown",
            class: "subtle-gold"
          }, null, 512 /* NEED_PATCH */)), [
            [_directive_tooltip, `${__props.user.userName} is the session owner.`]
          ])
        : _createCommentVNode("v-if", true),
      (__props.user.userID === __props.sessionOwner && __props.user.userID !== __props.self && __props.canRequestTakeover)
        ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 1,
            icon: "fa-solid fa-user-slash",
            class: "clickable red takeover",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('requestTakeover')))
          }, null, 512 /* NEED_PATCH */)), [
            [_directive_tooltip, `Vote to remove ${__props.user.userName} from the session and take ownership.`]
          ])
        : _createCommentVNode("v-if", true),
      (__props.self === __props.sessionOwner && __props.user.userID !== __props.sessionOwner)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _withDirectives(_createElementVNode("img", {
              src: _imports_0,
              class: "clickable",
              style: {"height":"18px","margin-top":"-4px"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('setSessionOwner', __props.user.userID)))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, `Give session ownership to ${__props.user.userName}`]
            ]),
            _withDirectives(_createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-user-slash",
              class: "clickable red",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('removePlayer', __props.user.userID)))
            }, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, `Remove ${__props.user.userName} from the session`]
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (!__props.useCustomCardList && !__props.ignoreCollections)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            (!__props.user.collection)
              ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "fa-solid fa-book",
                  class: "red"
                }, null, 512 /* NEED_PATCH */)), [
                  [_directive_tooltip, __props.user.userName + ' has not uploaded their collection yet.']
                ])
              : (__props.user.collection && !__props.user.useCollection)
                ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "fa-solid fa-book",
                    class: "yellow"
                  }, null, 512 /* NEED_PATCH */)), [
                    [_directive_tooltip, __props.user.userName + ' has uploaded their collection, but is not using it.']
                  ])
                : _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 2,
                    icon: "fa-solid fa-book",
                    class: "green"
                  }, null, 512 /* NEED_PATCH */)), [
                    [_directive_tooltip, __props.user.userName + ' has uploaded their collection.']
                  ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (__props.pendingReadyCheck)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            (__props.user.readyState == _unref(ReadyState).Ready)
              ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: "fa-solid fa-check",
                  class: "green"
                }, null, 512 /* NEED_PATCH */)), [
                  [_directive_tooltip, `${__props.user.userName} is ready!`]
                ])
              : (__props.user.readyState == _unref(ReadyState).NotReady)
                ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "fa-solid fa-times",
                    class: "red"
                  }, null, 512 /* NEED_PATCH */)), [
                    [_directive_tooltip, `${__props.user.userName} is NOT ready!`]
                  ])
                : (__props.user.readyState == _unref(ReadyState).Unknown)
                  ? _withDirectives((_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 2,
                      icon: "fa-solid fa-spinner",
                      spin: ""
                    }, null, 512 /* NEED_PATCH */)), [
                      [_directive_tooltip, `Waiting for ${__props.user.userName} to respond...`]
                    ])
                  : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: "chat-bubble",
      id: 'chat-bubble-' + __props.user.userID
    }, null, 8 /* PROPS */, _hoisted_4)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})